export default "__VITE_ASSET__383fced2__"